module.exports = __webpack_public_path__ + "img/ic-arrow-hover-default.53e045b7.svg";